/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import * as type from './type';
/**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */
export function jsonObjectOrNull(s) {
 var obj;
 try {
 obj = JSON.parse(s);
 }
 catch (e) {
 return null;
 }
 if (type.isNonArrayObject(obj)) {
 return obj;
 }
 else {
 return null;
 }
}

//# sourceMappingURL=json.js.map



//////////////////
// WEBPACK FOOTER
// ../storage/dist/esm/src/implementation/json.js
// module id = null
// module chunks = 